module.exports = __webpack_public_path__ + "img/process-xs.en.96a85a71.png";